// extracted by mini-css-extract-plugin
export default {"faqs":"hC-z","faqContent":"iC-z","faq":"jC-z"};